export function softwareEventsJson (language) {
  let items

  if (language === 'es') {
    items = {
      exportPdf: {
        name: 'exportPdf',
        label: 'exportar eventos en formato pdf'
      },
      exportCsv: {
        name: 'exportCsv',
        label: 'exportar eventos en formato csv'
      }
    }
  } else if (language === 'en') {
    items = {
      exportPdf: {
        name: 'exportPdf',
        label: 'export events in PDF format'
      },
      exportCsv: {
        name: 'exportCsv',
        label: 'export events in CSV format'
      }
    }
  }

  return (items)
}
